import { z } from 'zod';
import { FieldSchemaBuilder } from './build-field-schema.types';
import { buildDateFieldSchema } from './schemas/date-field.schema';
import { buildTextFieldSchema } from './schemas/text-field.schema';
import { buildNumberFieldSchema } from './schemas/number-field.schema';
import { FieldType, FormField } from '../../dynamic-form.types';

const fieldSchemaBuilders: Record<FieldType, FieldSchemaBuilder> = {
  date: buildDateFieldSchema,
  'text-input': buildTextFieldSchema,
  number: buildNumberFieldSchema,
};

const buildFieldSchema = (field: FormField) => {
  const builder = fieldSchemaBuilders[field.type];

  if (!builder) {
    throw new Error(`Unsupported field type: ${field.type}`);
  }

  return builder(field);
};

export const buildFieldSchemas = (items: FormField[]) => {
  const schemas: Record<string, z.ZodTypeAny> = {};

  items.forEach((field) => {
    schemas[field.key] = buildFieldSchema(field);
  });

  return schemas;
};
